import { render, staticRenderFns } from "./TestResultDetails.vue?vue&type=template&id=f4db35a6&scoped=true&"
import script from "./TestResultDetails.vue?vue&type=script&lang=js&"
export * from "./TestResultDetails.vue?vue&type=script&lang=js&"
import style0 from "./TestResultDetails.vue?vue&type=style&index=0&id=f4db35a6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4db35a6",
  null
  
)

export default component.exports